import { render, staticRenderFns } from "./MultipleListBlock.vue?vue&type=template&id=0dbb57b6&scoped=true&"
import script from "./MultipleListBlock.vue?vue&type=script&lang=js&"
export * from "./MultipleListBlock.vue?vue&type=script&lang=js&"
import style0 from "@/style/table.css?vue&type=style&index=0&id=0dbb57b6&scoped=true&lang=css&"
import style1 from "./MultipleListBlock.vue?vue&type=style&index=1&id=0dbb57b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbb57b6",
  null
  
)

export default component.exports